import * as yup from 'yup'

export const schemaSignIn = yup.object().shape({
  email: yup.string().required('Enter an email').email('Enter a correct email'),
  password: yup.string().required('Enter a password').min(8, 'Password must have at least 8 characters'),
  remember: yup.boolean(),
})
